/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
  Modal,
  Form,
  Input,
  Button,
  // Select,
} from 'antd';
import {
  ArrowLeftOutlined,
  SaveOutlined,
  EditOutlined,
  ArrowRightOutlined,
} from '@ant-design/icons';
import FormSubmitControls from 'components/FormSubmitCustomControls';
import LadaNumero from 'components/LadaNumero';
import { CURP_PATTERN, digitoVerificador, RFC_PATTERN } from 'utils/patterns';
import { patchCiudadano } from 'api/cuentaunicasir/ciudadanos';
import { patchEmpresa } from 'api/empresas/empresas';
import { DATETIME_FRONTEND_FORMAT, discartNullValues } from 'utils/formatValues';
import Select from 'components/Select';
import { hasActionPermission, ActionsNames } from 'utils/permission/index';
import { useSelector, useDispatch } from 'react-redux';
import { SET_PIN_PADRON_INFO } from 'store/reducers/caja';
import padronToString from 'utils/padronesToString';
import toCurrency from 'utils/toCurrency';
import { patchContribuyente, getContribuyente } from 'api/empresas/contribuyente';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import address from 'utils/address';
import { getTipoDeContrato, getTipoDeEspacio, getTipoDePanteon } from 'api/recaudacion';
import Moment from 'moment';
import { listToString } from 'utils/normalizers';
import {
  getRegimenesDePropiedad,
  getTipoDePredio,
  getUsosDePredio,
  getTiposDeAseos,
  getZonasDePredios,
} from 'api/catastro';
import { getTiposDeMercado } from 'api/catalogos/tiposDeMercado';
import { getZonasDeMercados } from 'api/catalogos/zonasDeMercado';
import { getGirosMercados } from 'api/empresas/giroDeMercado';
import { getPlazasDeMercados } from 'api/catalogos/plazasDeMercado';
import GirosDeComercios from 'components/ComerciosDeEmpresas';
import { getTipoDeEmpresa } from 'api/empresas';
import { getPuestoDeComercio } from 'api/catalogos/puestosDeComercioInformal';
import { getPerimetro } from 'api/catalogos/perimetros';
import { getMercadoDeModulo } from 'api/empresas/mercadosDeModulos';
import GirosDeModulos from 'components/GirosDeModulos';
import { getZonaDeModulo } from 'api/empresas/zonasDeModulo';

export const models = {
  1: 'ciudadano',
  2: 'empresa',
  15: 'contribuyente',
};

// const permissionConfig = {
//   title: 'Giros de Comercio',
//   model: 'girocomercial',
//   catalogs: [
//     'tipodegirocomercial',
//   ],
// };

const ModalInfoPadron = ({
  callback,
  unidadesRecaudadoras,
  gpm,
}) => {
  const dispatch = useDispatch();
  const padron = useSelector(({ caja }) => caja.pinPadronInfo);
  const [formCiudadano] = Form.useForm();
  const [formEmpresa] = Form.useForm();
  const [formPredio] = Form.useForm();
  const [formVehiculo] = Form.useForm();
  const [formMercados] = Form.useForm();
  const [formVia] = Form.useForm();
  const [formModulos] = Form.useForm();
  const [formDefault] = Form.useForm();
  const [isEditing, setIsEditing] = useState(gpm);
  const [canChange, setCanChange] = useState(true);
  const forms = {
    1: formCiudadano,
    2: formEmpresa,
    3: formPredio,
    4: formVehiculo,
    15: formCiudadano,
    20: formVia,
    21: formMercados,
    32: formModulos,
  };
  const form = (forms[padron?.tipo_de_padron] || formDefault);
  const fetchCatalogs = async () => {
    if (padron?.tipo_de_padron === padronesEnum.MODULOS) {
      const direccion = padron?.contribuyente?.direcciones ? address(padron?.contribuyente?.direcciones) : 'Desconocida';
      const objeto_cuenta = padron?.clave;
      const _mercados = padron?.mercado_de_modulos
        ? await getMercadoDeModulo(padron?.mercado_de_modulo) : null;
      const mercado = _mercados ? _mercados?.descripcion : 'Desconocido';
      const _zona = padron?.zona_de_modulo
        ? await getZonaDeModulo(padron?.zona_de_modulo) : null;
      const zona = _zona ? _zona?.descripcion : 'Desconocido';
      formModulos.setFieldsValue({
        propietario: padron?.contribuyente?.nombre_completo || 'No tiene registrado contribuyente',
        direccion,
        objeto_cuenta,
        mercado,
        metros_largo: padron?.metros_de_largo,
        metros_ancho: padron?.metros_de_ancho,
        superficie: padron?.superficie,
        local: padron?.numero_de_puesto,
        numero_de_locales: padron?.numero_de_locales,
        zona,
      });
    }
    if (padron?.tipo_de_padron === padronesEnum.COMERCIO_INFORMAL) {
      const direccion = padron?.contribuyente?.direcciones ? address(padron?.contribuyente?.direcciones) : 'Desconocida';
      const objeto_cuenta = padron?.clave;
      const _tipoDePuesto = padron?.tipo_puesto
        ? await getPuestoDeComercio(padron?.tipo_puesto) : null;
      const tipo_de_puesto = _tipoDePuesto ? _tipoDePuesto?.descripcion : 'Desconocido';
      const _perimetro = padron?.perimetro ? await getPerimetro(padron?.perimetro) : null;
      const perimetro = _perimetro ? _perimetro?.descripcion : 'Desconocido';
      formVia.setFieldsValue({
        propietario: padron?.contribuyente?.nombre_completo,
        direccion,
        objeto_cuenta,
        denominacion: padron?.denominacion,
        tipo_de_puesto,
        perimetro,
        numero_dias: padron?.num_dias,
        horario: padron?.horario,
        metros_largo: padron?.mts_largo,
        metros_ancho: padron?.mts_ancho,
        superficie: padron?.area_m2,
        organizacion: padron?.organizacion,
      });
    }
    if (padron?.tipo_de_padron === padronesEnum.EMPRESA) {
      const _tipoDeEmpresa = padron?.tipo_de_empresa
        ? await getTipoDeEmpresa(padron?.tipo_de_empresa)
        : null;
      const tipoDeEmpresa = _tipoDeEmpresa ? _tipoDeEmpresa?.descripcion : 'Desconocida';
      const direccion = padron?.direccion_de_ubicacion ? address(padron?.direccion_de_ubicacion) : 'Desconocida';
      const rfc = padron?.contribuyente?.rfc ? padron?.contribuyente?.rfc : 'El contribuyente no tiene RFC';
      const nombre_comercial = padron?.nombre_comercial ? padron?.nombre_comercial : 'Conocido';
      formEmpresa.setFieldsValue({
        tipo_de_empresa: tipoDeEmpresa,
        direccion,
        rfc,
        nombre_comercial,
      });
    }
    if (padron?.tipo_de_padron === padronesEnum.LOTES_DE_PANTEON) {
      const _propietario = padron?.contributente ? await getContribuyente(padron.contributente?.id)
        : padron.nombre_completo_ciudadano;
      const propietarioAsString = padron?.contributente ? padronToString(_propietario, 15)
        : _propietario;
      const direccion = padron?.contributente && _propietario?.direcciones
        ? address(_propietario.direcciones) : 'Desconocida';
      const _panteon = padron?.panteon ? await getTipoDePanteon(padron.panteon) : null;
      const panteon = _panteon ? _panteon.descripcion : 'Desconocido';
      const _contrato = padron?.tipo_contrato
        ? await getTipoDeContrato(padron.tipo_contrato) : null;
      const fecha_de_contratacion = padron?.fecha_de_compra
        ? new Moment(padron.fecha_de_compra).format(DATETIME_FRONTEND_FORMAT) : 'Desconocida';

      const _tipoDeEspacio = padron?.espacio ? await getTipoDeEspacio(padron.espacio) : null;

      const espacio = _tipoDeEspacio ? _tipoDeEspacio.descripcion : 'Desconocido';

      const vuelta_o_frente = padron?.frente_vuelta ? 'Frente' : 'Vuelta';

      form.setFieldsValue({
        propietario: propietarioAsString,
        direccion,
        folio: padron.folio,
        panteon,
        contrato: _contrato?.descripcion,
        fecha_de_contratacion,
        vuelta_o_frente,
        espacio,
      });
    }
    if (padron?.tipo_de_padron === padronesEnum.PREDIO) {
      const [
        tiposDePredios,
        usosDePredio,
        regimenesDePropiedad,
        zonas,
        tiposDeAseos,
      ] = await Promise.all([
        getTipoDePredio(),
        getUsosDePredio(),
        getRegimenesDePropiedad(),
        getZonasDePredios(),
        getTiposDeAseos(),
      ]);
      const propietarios = padron?.nombres_de_participes?.length
        ? listToString(padron.nombres_de_participes) : 'Desconocido';
      const direccion = padron?.direccion ? address(padron.direccion) : 'Desconocida';
      const _tipoDePredio = padron?.tipo_de_predio
        ? tiposDePredios.find((t) => t.id === padron.tipo_de_predio) : null;
      const tipo_de_predio = _tipoDePredio ? _tipoDePredio.descripcion : 'Desconocido';
      const valor_del_terreno = toCurrency(padron?.valor_del_terreno || 0);
      const valor_de_la_construccion = toCurrency(padron?.valor_de_la_construccion || 0);
      const base_gravable = toCurrency(padron?.base_gravable || 0);
      const _usoDePredio = padron?.uso_de_predio
        ? usosDePredio.find((u) => u.id === padron.uso_de_predio) : null;
      const uso_de_predio = _usoDePredio ? _usoDePredio.descripcion : 'Desconocido';
      const _regimenDePropiedad = padron?.regimen_de_propiedad
        ? regimenesDePropiedad.find((r) => r.id === padron.regimen_de_propiedad) : null;
      const regimen_de_propiedad = _regimenDePropiedad
        ? _regimenDePropiedad.descripcion : 'Desconocido';
      const _zona = padron?.zona ? zonas.find((z) => z.id === padron.zona) : null;
      const zona = _zona ? `${_zona.clave} - ${_zona.descripcion}` : 'Desconocido';
      const _tipoDeAseo = padron?.tipo_de_aseo
        ? tiposDeAseos.find((t) => t.id === padron.tipo_de_aseo) : null;
      const tipo_de_aseo = _tipoDeAseo?.descripcion || 'Desconocido';
      form.setFieldsValue({
        propietarios,
        direccion,
        clave_catastral_estandar: padron.clave_catastral_estandar,
        clave: padron.clave,
        clave_catastral_municipal: padron.clave_catastral_municipal,
        CURT: padron.CURT,
        base_gravable,
        tipo_de_predio,
        superficie_total_del_terreno: padron.superficie_total_del_terreno,
        valor_del_terreno,
        superficie_de_la_construccion: padron.superficie_de_la_construccion,
        valor_de_la_construccion,
        uso_de_predio,
        regimen_de_propiedad,
        zona,
        tipo_de_aseo,
      });
    }
    if (padron?.tipo_de_padron === padronesEnum.MERCADO) {
      const [
        tipoDepuesto,
        zonas,
        giros,
        plazas,
      ] = await Promise.all([
        getTiposDeMercado(),
        getZonasDeMercados(),
        getGirosMercados(),
        getPlazasDeMercados(),
      ]);
      const contribuyente = padron?.contribuyente?.nombre_completo;
      const direccion = padron?.contribuyente?.direcciones ? address(padron?.contribuyente.direcciones) : 'Desconocida';
      const _tiposDePuesto = padron?.tipos_de_mercados
        ? tipoDepuesto.find((t) => t.id === padron.tipos_de_mercados) : null;
      const tipos_de_mercados = _tiposDePuesto ? _tiposDePuesto.descripcion : 'Desconocido';
      const _giros = padron?.giro_principal
        ? giros.find((g) => g.id === padron?.giro_principal) : null;
      const giro_principal = _giros ? _giros.descripcion : 'Desconocido';
      const _plazas = padron?.plaza
        ? plazas.find((p) => p.id === padron.plaza) : null;
      const plaza = plazas
        ? _plazas?.descripcion : 'Desconocido';
      const _zona = padron?.zona ? zonas.find((z) => z.id === padron.zona) : null;
      const zona = _zona ? _zona?.descripcion : 'Desconocido';
      form.setFieldsValue({
        contribuyente,
        direccion,
        clave: padron.clave,
        mercado: padron?.mercado?.descripcion,
        tipos_de_mercados,
        zona,
        local: padron?.local,
        num_locales: padron?.num_locales,
        giro_principal,
        mts_largo: padron?.mts_largo,
        mts_ancho: padron?.mts_ancho,
        num_dias: padron?.num_dias,
        plaza,
      });
    }
  };

  const setValues = (_padron) => {
    if (_padron) {
      const values = discartNullValues(_padron);
      fetchCatalogs();
      setTimeout(() => form.setFieldsValue(values));
    }
  };

  useEffect(() => {
    let mounted = true;
    const _canChange = hasActionPermission(models[padron?.tipo_de_padron], ActionsNames.change);
    if (mounted) {
      form.resetFields();
      setCanChange(_canChange);
      setValues(padron);
    }
    return () => { mounted = false; };
  }, [padron]);

  const onFinish = async (values) => {
    const updaters = {
      1: patchCiudadano,
      2: patchEmpresa,
      15: patchContribuyente,
    };
    const edited = await updaters[padron.tipo_de_padron](padron.id, values);
    if (edited) {
      callback({ ...padron, ...edited });
      form.resetFields();
      if (!gpm) {
        setIsEditing(false);
      } else {
        setValues({ ...padron, ...edited });
      }
    }
  };

  const saveControl = {
    text: 'Guardar',
    icon: <SaveOutlined />,
    onClick: form?.submit,
  };

  const editControl = {
    text: 'Editar',
    icon: <EditOutlined />,
    onClick: () => setIsEditing(true),
  };

  const backControl = {
    text: 'Regresar',
    icon: <ArrowLeftOutlined />,
    onClick: () => {
      dispatch({ type: SET_PIN_PADRON_INFO });
      if (!gpm) {
        setIsEditing(false);
      }
      (forms[padron.tipo_de_padron] || formDefault).resetFields();
    },
  };

  const cancelControl = {
    text: 'Cancelar',
    icon: <ArrowLeftOutlined />,
    onClick: () => {
      if (gpm) {
        dispatch({ type: SET_PIN_PADRON_INFO });
      }
      if (!gpm) {
        setIsEditing(false);
      }
      (forms[padron.tipo_de_padron] || formDefault).setFieldsValue(padron);
    },
  };

  const continueControl = {
    text: 'Continuar',
    rigthIcon: <ArrowRightOutlined />,
    onClick: () => callback({ ...padron, continuarSinInfoContacto: true }),
  };

  const getControls = () => {
    if (isEditing) return [cancelControl, saveControl, gpm && continueControl].filter((e) => e);
    if (![2, 3, 4, padronesEnum.LOTES_DE_PANTEON]
      .includes(padron.tipo_de_padron) && canChange) return [backControl, editControl];
    return [backControl];
  };

  const rules = {
    RFC: [
      {
        pattern: RFC_PATTERN,
        message: 'Ingrese un RFC válido',
      },
    ],
    curp: [
      {
        validator: async (_, value) => {
          if (value) {
            const validado = value.toUpperCase().match(CURP_PATTERN);
            if (!validado || validado[2] !== digitoVerificador(validado[1])) {
              throw new Error('Ingrese una CURP válida');
            }
          }
        },
      },
    ],
    email: [
      {
        type: 'email',
        message: 'Ingrese un correo válido',
      },
    ],
    numero_de_telefono: [
      {
        pattern: /^(?:[0-9]{10}|)$/,
        message: 'Ingrese un número celular válido',
      },
    ],
  };

  if (!padron) {
    return null;
  }
  const getWidthModal = () => {
    if (padron.tipo_de_padron === 2) {
      return '80%';
    }
    return '520px';
  };

  return (
    <Modal
      footer={null}
      closable={false}
      open={!!padron}
      width={getWidthModal()}
      title={(
        <FormSubmitControls
          label={padronToString(padron, padron.tipo_de_padron, true)}
          controls={getControls()}
          labelSpan={24}
          controlsSpan={24}
        />
      )}
    >
      <Row>
        <Col span={24}>
          {padron.tipo_de_padron === padronesEnum.LOTES_DE_PANTEON && (
            <Form
              name="lotes"
              layout="vertical"
              form={form}
              className="without-feedback"
              onFinish={onFinish}
            >
              <Row gutter={10}>
                <Col span={24}>
                  <Form.Item
                    name="propietario"
                    label="Propietario"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="direccion"
                    label="Dirección"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="folio"
                    label="Folio"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="panteon"
                    label="Panteón"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="contrato"
                    label="Contrato"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="fecha_de_contratacion"
                    label="Fecha de contratación"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="espacio"
                    label="Tipo de espacio"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="cantidad"
                    label="Cantidad de espacios"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="lote"
                    label="Lote"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="registro"
                    label="Registro"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="linea"
                    label="Línea"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="cuadro"
                    label="Cuadro"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="vuelta_o_frente"
                    label="Vuelta o frente"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="certificado"
                    label="Certificado"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="poliza"
                    label="Póliza"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="libro"
                    label="Libro"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
          {[1, 15].includes(padron.tipo_de_padron) && (
            <Form
              name="ciudadanos"
              layout="vertical"
              form={formCiudadano}
              onFinish={onFinish}
            >
              <Row>
                {padron.tipo_de_padron !== padronesEnum.LOTES_DE_PANTEON && (
                  <>
                    <Col span={24}>
                      <Form.Item
                        label="Clave"
                        name={padron?.tipo_de_padron === 1 ? 'clave_ciudadana' : 'clave'}
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="Nombre"
                        name="nombre_completo"
                      >
                        <Input disabled />
                      </Form.Item>
                    </Col>
                  </>
                )}
                {!gpm && (
                  <>
                    <Col span={24}>
                      <Form.Item
                        label="CURP"
                        name={padron?.tipo_de_padron === 1 ? 'CURP' : 'curp'}
                        rules={rules.curp}
                      >
                        <Input disabled={!isEditing} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Form.Item
                        label="INE"
                        name="INE"
                      >
                        <Input disabled={!isEditing} />
                      </Form.Item>
                    </Col>
                  </>
                )}
                <LadaNumero
                  rules={rules}
                  form={formCiudadano}
                  names={{
                    lada: padron?.tipo_de_padron === 1 ? 'lada' : 'lada_celular',
                    numero_de_telefono: padron?.tipo_de_padron === 1 ? 'numero_de_celular' : 'telefono_celular',
                  }}
                  fullSize
                  disabled={!isEditing}
                  hasFeedback={isEditing}
                />
                <Col span={24}>
                  <Form.Item
                    label="Correo"
                    rules={rules.email}
                    name={padron?.tipo_de_padron === 1 ? 'email' : 'correo_electronico'}
                    hasFeedback={isEditing}
                  >
                    <Input disabled={!isEditing} />
                  </Form.Item>
                </Col>
                {!gpm && (
                  <Col span={24}>
                    <Form.Item
                      label="RFC"
                      rules={rules.RFC}
                      name={padron?.tipo_de_padron === 1 ? 'RFC' : 'rfc'}
                      hasFeedback={isEditing}
                    >
                      <Input disabled={!isEditing} />
                    </Form.Item>
                  </Col>
                )}
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Row>
            </Form>
          )}
          {(padron.tipo_de_padron === 2) && (
            <Form
              name="empresas"
              layout="vertical"
              form={formEmpresa}
              onFinish={onFinish}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={12}>
                  <Form.Item
                    label="Denominación"
                    name="nombre_comercial"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Tipo de Empresa"
                    name="tipo_de_empresa"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="RFC"
                    name="rfc"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Direccion de Ubicación"
                    name="direccion"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>

                <GirosDeComercios
                  empresa={padron?.id}
                  justView
                />
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Row>
            </Form>
          )}
          {(padron.tipo_de_padron === padronesEnum.MODULOS) && (
            <Form
              name="modulos"
              layout="vertical"
              form={formModulos}
              onFinish={onFinish}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    label="Propietario"
                    name="propietario"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    label="Dirección"
                    name="direccion"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Objeto Cuenta"
                    name="objeto_cuenta"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Mercado"
                    name="mercado"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Local"
                    name="numero_de_puesto"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Zona"
                    name="zona"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Cantidad de Puestos"
                    name="numero_de_locales"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Metros Largo"
                    name="metros_largo"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Metros Ancho"
                    name="metros_ancho"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Superficie"
                    name="superficie"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Organizacion"
                    name="organizacion"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <GirosDeModulos
                  expediente_modulo={padron?.id}
                  justView
                />
              </Row>
            </Form>
          )}
          {(padron.tipo_de_padron === padronesEnum.COMERCIO_INFORMAL) && (
            <Form
              name="via"
              layout="vertical"
              form={formVia}
              onFinish={onFinish}
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    label="Propietario"
                    name="propietario"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={24}>
                  <Form.Item
                    label="Dirección"
                    name="direccion"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Objeto Cuenta"
                    name="objeto_cuenta"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Tipo de Puesto"
                    name="tipo_de_puesto"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Tipo de Perimetro"
                    name="perimetro"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Denominacion"
                    name="denominacion"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="No. Dias"
                    name="num_dias"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Horario"
                    name="horario"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Metros Largo"
                    name="mts_largo"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Metros Ancho"
                    name="mts_ancho"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Superficie"
                    name="superficie"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Organizacion"
                    name="organizacion"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
          {padron.tipo_de_padron === padronesEnum.PREDIO && (
            <Form
              name="prediales"
              layout="vertical"
              form={formPredio}
              className="without-feedback"
              onFinish={onFinish}
            >
              {/* 1010000015867 */}
              <Row gutter={10}>
                <Col span={24}>
                  <Form.Item
                    name="propietarios"
                    label="Propietario"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="direccion"
                    label="Dirección"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="clave_catastral_estandar"
                    label="Clave catastral estándar"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="clave"
                    label="Cuenta unica predial"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="clave_catastral_municipal"
                    label="No. Cuenta"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="CURT"
                    label="CURT"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="base_gravable"
                    label="Base Gravable"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="tipo_de_predio"
                    label="tipo de predio"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="superficie_total_del_terreno"
                    label="Superficie del terreno"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="valor_del_terreno"
                    label="Valor del terreno"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="superficie_de_la_construccion"
                    label="Superficie de la construcción"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="valor_de_la_construccion"
                    label="Valor de la construcción"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="uso_de_predio"
                    label="Uso de predio"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="regimen_de_propiedad"
                    label="Regimen de propiedad"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="zona"
                    label="Zona"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="tipo_de_aseo"
                    label="Tipo de aseo"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
          {padron.tipo_de_padron === padronesEnum.MERCADO && (
            <Form
              name="mercados"
              layout="vertical"
              form={formMercados}
              className="without-feedback"
              onFinish={onFinish}
            >
              {/* 1010000015867 */}
              <Row gutter={10}>
                <Col span={24}>
                  <Form.Item
                    name="contribuyente"
                    label="Contribuyente"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="direccion"
                    label="Dirección del contribuyente"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="clave"
                    label="Clave"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="mercado"
                    label="Mercado"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="tipos_de_mercados"
                    label="Tipo de puesto"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="zona"
                    label="Zona"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="local"
                    label="Numero de Puesto"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="num_locales"
                    label="Número de locales"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="giro_principal"
                    label="Giro"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="mts_largo"
                    label="Metros de largo"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="mts_ancho"
                    label="Metros de ancho"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="num_dias"
                    label="Numero de dias laborales"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col sm={24} md={12}>
                  <Form.Item
                    name="plaza"
                    label="Plaza"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
          {padron.tipo_de_padron === 4 && (
            <Form
              name="vehiculos"
              layout="vertical"
              form={formVehiculo}
              className="without-feedback"
              onFinish={onFinish}
            >
              <Row>
                <Col span={24}>
                  <Form.Item
                    name="clave"
                    label="Clave"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="numero_de_identificacion_vehicular"
                    label="Serie"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    name="numero_de_placa_vigente"
                    label="Número de Placa"
                  >
                    <Input disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
          {![1, 2, 3, 4, 15, 21, padronesEnum.LOTES_DE_PANTEON, padronesEnum.MODULOS]
            .includes(padron.tipo_de_padron) && (
            <Form
              name="default"
              layout="vertical"
              form={formDefault}
              onFinish={onFinish}
            >
              <Row gutter={10}>
                <Col span={24}>
                  <Form.Item
                    label="clave"
                    name="clave"
                  >
                    <Input allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="Descripción"
                    name="descripcion"
                  >
                    <Input allowClear disabled />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    label="unidad recaudadora"
                    name="unidad_recaudadora"
                  >
                    <Select dataSource={unidadesRecaudadoras} disabled />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}
        </Col>
      </Row>
    </Modal>
  );
};

ModalInfoPadron.propTypes = {
  callback: PropTypes.func,
  unidadesRecaudadoras: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  gpm: PropTypes.bool,
};

ModalInfoPadron.defaultProps = {
  callback: () => {},
  gpm: false,
};

export default ModalInfoPadron;
